import { FEATURE_LOYALTY_UI_SINGLETON } from 'features/content/hooks/use-feature-loyalty-ui';

import { useFeatureLoyaltyShortCodeConfirmationModalQuery } from 'generated/sanity-graphql';

export const useShortCodeConfirmationModal = () => {
  const { data, loading } = useFeatureLoyaltyShortCodeConfirmationModalQuery({
    variables: { featureLoyaltyUIId: FEATURE_LOYALTY_UI_SINGLETON },
  });

  return { data: data?.LoyaltyUI, loading };
};
